import {
  exchangeAgentGuidanceIdFormat,
  productFamilyIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const createExchangeAgentGuidance = {
  name: "createExchangeAgentGuidance" as const,
  input: z.object({
    name: z.string().min(1),
    returnProductIds: z.array(productFamilyIdFormat.schema),
    recommendations: z.array(
      z.object({
        context: z.string(),
        productIds: z.array(productFamilyIdFormat.schema),
      }),
    ),
  }),
  output: z.object({ id: exchangeAgentGuidanceIdFormat.schema }),
};
